<template>
  <div id="app" v-loading="$store.state.pageLoding">
    <router-view v-if="$store.state.registry" />
    <guidance v-if="!$store.state.registry && !$store.state.pageLoding" />

    <!-- 字体大小变化影响测试 -->
    <!-- <div
      style="
        height: 1em;
        width: 1em;
        background-color: #000000;
        position: fixed;
        top: 0;
      "
    ></div> -->
  </div>
</template>

<script>
// import WeixinInit from "@/utils/weixin";
import guidance from "./views/guidance.vue";
export default {
  name: "App",
  components: { guidance },
  data() {
    return {
      // wxSign: false,
      // local: process.env.VUE_APP_ENV == 'localhost',
    }
  },
  // async mounted() {
  //   try {
  //     // 微信初始化
  //     this.wxSign = await new WeixinInit().init()
  //     // console.log("wx = ", this.wxSign);
  //   } catch (e) {
  //     console.log(e)
  //   }
  // },
};
</script>

<style>
/* IOS禁止微信调整字体大小 */
/* body {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
} */

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 10px;
  font-size: 16px;
}

.goods {
  /* color: #D72618; */
  font-weight: 800;
  text-decoration: none !important;
}

/* EL加载动画样式 */
.el-loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff !important;
}

.chatbot-q-content hr {
  opacity: 0;
  margin: 4px 0;
}
</style>